import React from 'react';


const Interiors = ({ inspectionData }) => {
  return (
    <section className="Interiors-section">
      <div className="container">
        <div className="inner-content">
          <div className="Interiors-wrapper">
            <div className="text-wrapper">
              {inspectionData.slice(0, 5).map((section, index) => (
                <p key={index}>
                  <b>{section.title} – </b>{section.items[0]}
                </p>
              ))}
            </div>
          </div>

          <div className="img-box">
            <img src="./images/home_inspection.png" alt="Home Inspection" />
          </div>

          <div className="Interiors-wrapper">
            <div className="text-wrapper">
              {inspectionData.slice(5).map((section, index) => (
                <p key={index}>
                  <b>{section.title} – </b>{section.items[0]}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Interiors;
